import { render } from "./ConfigManual.vue?vue&type=template&id=23075751"
import script from "./ConfigManual.vue?vue&type=script&lang=ts"
export * from "./ConfigManual.vue?vue&type=script&lang=ts"
script.render = render

export default script